import type { HistoryItem } from '../types/terminal'
import { HIDDEN_COMMANDS } from './commands'

export const executeCommand = (
  cmd: string,
  setHistory: (updater: (prev: HistoryItem[]) => HistoryItem[]) => void
): void => {
  const trimmedCmd = cmd.trim().toLowerCase()
  
  if (trimmedCmd === 'clear') {
    setHistory(() => [])
    return
  }

  const command = HIDDEN_COMMANDS.find(c => c.cmd === trimmedCmd)
  
  setHistory(prev => [
    ...prev,
    { type: 'input', content: `$ ${cmd}` },
    { 
      type: 'output', 
      content: command 
        ? command.output 
        : `Command not found: ${trimmedCmd}. Type "help" for available commands.` 
    },
  ])
}

